<app-loader *ngIf="isLoadingDetails" [zIndex]="100"></app-loader>
<h2 class="mb-4 color-royal-blue-500">Property Details</h2>
<div class="row mb-3">
  <div class="col-lg-6">
    <div class="row d-flex flex-column h-100">
      <div class="col-md-12">
        <h4 class="color-royal-blue-500" yp-e2e-id="property-type">
          {{propertyDetails?.bedrooms}} bedroom {{propertyDetails?.propertyReviewType?.title}}
        </h4>
        <h5 class="color-grey-500" yp-e2e-id="property-address">
          {{propertyDetails?.address1}},
          {{propertyDetails?.town}},
          {{propertyDetails?.outcode}}
        </h5>
      </div>
      <div class="col-md-12 mt-3 flex-grow-1 mb-4 mb-lg-0">
        <app-image-slider
          *ngIf="hasPropertyImages()"
          [showPagination]="true"
          [showNavigation]="true"
          [images]="propertyImages"></app-image-slider>
        <div *ngIf="!hasPropertyImages()"
             class="no-images-available-banner"
             yp-e2e-id="property-no-image-available-banner">no image available</div>
      </div>
    </div>
  </div>

  <div class="col-lg-6 d-flex">
    <div class="row d-flex flex-column w-100">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-6 d-flex mb-3 mb-lg-0">
            <h5 class="text-with-category-title--property-details" yp-e2e-id="property-price">
              <span class="overflow-hidden" yp-e2e-id="property-price-qualifier">Price
                <span *ngIf="haspPriceQualifier()" class="d-inline-block text-truncate"
                      bind-innerText="propertyDetails.priceQualifierRelation?.priceQualifier" [tooltip]="propertyDetails.priceQualifierRelation?.priceQualifier"></span>
              </span>
              <span class="d-inline-block text-truncate h5 no-border" [tooltip]="propertyDetails?.price | currency:'GBP':'symbol':'1.0-0'">
                {{propertyDetails?.price | currency:'GBP':'symbol':'1.0-0'}}
              </span>
            </h5>
          </div>
          <div class="col-lg-6 d-flex mb-lg-0">
            <h5 class="text-with-category-title--property-details text-capitalize" yp-e2e-id="property-status">
              <span>
                Status
                <span class="d-md-none d-lg-inline-block" *ngIf="haspPriceQualifier()">&nbsp;</span>
              </span>
              <span class="d-inline-block h5 text-truncate no-border" [tooltip]="propertyDetails?.propertyStatus?.description">{{propertyDetails?.propertyStatus?.description}}</span></h5>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-flex flex-column flex-grow-1 mt-4">
        <div class="nav nav-tabs mb-3" role="tablist">
          <a *ngIf="hasPropertyKeyFeatures()"
             [class.active]="hasPropertyKeyFeatures()"
             yp-e2e-id="property-tab-key-features"
             class="nav-link"
             data-bs-toggle="tab"
             href="#tab-features"
             role="tab">Key features</a>
          <a class="nav-link"
             [class.active]="!hasPropertyKeyFeatures()"
             yp-e2e-id="property-tab-location"
             data-bs-toggle="tab" href="#tab-location" role="tab">Location</a>
          <a *ngIf="hasPropertyFloorPlan()"
             yp-e2e-id="property-tab-floor-plan"
             class="popup-link ml-auto"
             data-bs-toggle="modal"
             data-bs-target="#floor-plan-modal"
             href="#"><span class="d-none d-md-inline">Open</span> Floor plan</a>
        </div>
        <div class="d-flex flex-column tab-content flex-grow-1">
          <div *ngIf="hasPropertyKeyFeatures()"
               [class.active]="hasPropertyKeyFeatures()"
               class="tab-pane fade show"
               id="tab-features"
               role="tabpanel">
            <ul class="disc-list key-features" yp-e2e-id="property-key-features">
              <li *ngFor="let feature of propertyDetails.propertyFeatures; let i = index"
                  [attr.yp-e2e-id]="'property-key-features-' + i">{{feature.content}}</li>
            </ul>
          </div>
          <div class="tab-pane fade flex-grow-1"
               [class.active]="!hasPropertyKeyFeatures()"
               id="tab-location" role="tabpanel">
            <div *ngIf="googleApiLoaded | async" style="width: 100%; height: 100%;">
              <google-map width="100%"
                          height="100%"
                          [center]="mapCenter">
                <map-marker [position]="mapCenter"></map-marker>
              </google-map>
            </div>
          </div>
        </div>
        <div *ngIf="hasPropertyFloorPlan()" class="modal fade" id="floor-plan-modal" tabindex="-1"
             yp-e2e-id="property-floor-plan-modal">
          <div class="modal-dialog modal-dialog--clear modal-dialog-centered">
            <div class="modal-content">
              <img class="d-block w-100" [src]="propertyFloorPlan.thumbnails.large" alt=""
                   yp-e2e-id="property-floor-plan-modal-image"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <hr class="mb-3"/>
    <app-host-details></app-host-details>
  </div>
</div>
